import taxonomyService from '../main/taxonomyService';
import React from 'react';
import {ListGroupItem, ListGroup, Row, Col, Panel, PanelGroup} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {Redirect} from 'react-router-dom';
import {injectIntl, FormattedMessage} from "react-intl";
import i18n from "../main/i18n";

export default injectIntl(props => {

  const msg = i18n.getMsg(props.intl);
  const {serviceAreaId} = props.match.params;
  const serviceArea = taxonomyService.getServiceArea(serviceAreaId);
  const evidenceAreaTitle = msg(`customer.${process.env.REACT_APP_CUSTOMER}.evidenceAreaTitle`);

  if (!serviceArea) {
    return <Redirect to="/"/>;
  }

  const evidenceTypesByCategory = taxonomyService.getAllEvidenceTypes(serviceArea);
  const evidenceCategories = Object.keys(evidenceTypesByCategory);

  let evidenceTypesList = null;

  const showEvidenceCategory = categoryName => {
    const evidenceTypeItems = evidenceTypesByCategory[categoryName].map(evidenceType => {
      if (evidenceType.verificationRequired === true) {
        return (
          <LinkContainer to={`${props.match.url}/${evidenceType.id}/verification-required`} key={evidenceType.id}>
            <ListGroupItem>{evidenceType.label}</ListGroupItem>
          </LinkContainer>
        );
      }
      else {
        return (
          <LinkContainer to={`${props.match.url}/${evidenceType.id}`} key={evidenceType.id}>
            <ListGroupItem>{evidenceType.label}</ListGroupItem>
          </LinkContainer>
        );
      }
    });

    return <ListGroup>{evidenceTypeItems}</ListGroup>
  };

  if (evidenceCategories.length === 1) {
    evidenceTypesList = showEvidenceCategory(evidenceCategories[0]);

  } else if (evidenceCategories.length > 1) {
    // sort the evidence categories alphabetically
    evidenceCategories.sort((name1, name2) => name1.localeCompare(name2));

    // if there's a default (Other) category, move it to the end
    const defaultCategoryIndex = evidenceCategories.indexOf(taxonomyService.DEFAULT_CATEGORY_NAME);
    if (defaultCategoryIndex > -1) {
      evidenceCategories.splice(defaultCategoryIndex, 1);
      evidenceCategories.push(taxonomyService.DEFAULT_CATEGORY_NAME);
    }

    const categoryPanels = evidenceCategories.map((categoryName, index) => {
      return (
        <Panel eventKey={index} key={index}>
          <Panel.Heading>
            <Panel.Title toggle>
              {
                categoryName === taxonomyService.DEFAULT_CATEGORY_NAME ?
                  <FormattedMessage id="defaultEvidenceCategory" defaultMessage="(Other)"/> : categoryName
              }
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body collapsible>
            {showEvidenceCategory(categoryName)}
          </Panel.Body>
        </Panel>
      )
    });

    evidenceTypesList = <PanelGroup accordion id="evidence-type-categories">{categoryPanels}</PanelGroup>

  } else {
    console.error(`No evidence types found for service area: ${serviceAreaId}`);
    return <Redirect to="/"/>;
  }

  return (
    <Row>
      <Col md={6}>
        <h4>
          <FormattedMessage id="chooseEvidenceType" defaultMessage="{evidenceTitle}" values={{evidenceTitle: evidenceAreaTitle}}/>
        </h4>
        {evidenceTypesList}
      </Col>
    </Row>
  );
});
